module.exports = __webpack_public_path__ + "main/images/learnmore/listen-graphic.ad67fcf40deaf6d324843f20ddc0af59.svg";